// Coop Action View Docs
export const coopActionDocs = [
  {
    id: 'cgt_search',
    label: 'Corporate Action Search'
  }
];
